export const moduleConfig = {
    entityKey: 'orders',
    titles: {
        singular: 'Order',
        plural: 'Orders'
    }
}

export const initialSortState = {
    column: 'created',
    direction: 'desc',
};